import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { useController } from 'react-hook-form'
import { Input, InputGroup } from '@wmgtech/legato'

import { isRequired } from 'shared/utils/form'

import { FormInputProps } from './FormInput.props'
import './FormInput.scss'

const FormInput: FC<FormInputProps> = ({
  suffixIcon,
  label = '',
  control,
  fieldName,
  rules,
  dataTest,
  disabled,
  placeholder,
  className,
  autoComplete = 'off',
  validationIconPlacement = 'label',
  warning
}) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  return (
    <InputGroup
      className={cn('form-input-group', className, { 'form-input-group__error': error })}
      label={label}
      labelProps={{ icon: isRequired(rules) && label ? 'asterisk' : undefined }}
      validationIconPlacement={validationIconPlacement}
      validation={
        warning?.isShow && !error
          ? { message: warning?.message, type: 'warning' }
          : {
            message: error?.message,
            ...(error && { type: 'error' })
          }
      }
    >
      <Input
        crossOrigin
        data-test={dataTest}
        placeholder={placeholder}
        disabled={disabled}
        suffixIcon={suffixIcon}
        autoComplete={autoComplete}
        {...field}
      />
    </InputGroup>
  )
}

export default FormInput
